import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const slugify = (text) =>
  text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w\-]+/g, "")
    .replace(/\-\-+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");

const Skillup = () => {
  const { t } = useTranslation();
  const { categories, isLoading, error } = useSelector((state) => state?.category);

  return (
    <div className="min-h-screen bg-gradient-to-tr from-[#f9f9f9] to-[#e0e0e0] pt-24 px-4">
      {/* Breadcrumb */}
      <div className="mb-4 text-sm mt-3">
        <Link to="/" className="text-gray-600 hover:text-blue-700">
          {t("Home")}
        </Link>
        <span className="text-gray-400"> &gt; </span>
        <span className="text-gray-800 font-medium">{t("SkillUp Sitemap")}</span>
      </div>

      {/* Header */}
      <div className="text-center mb-12">
        <h1 className="text-4xl font-extrabold">
          {t("Explore Career SkillUp Paths")}
        </h1>
        <p className="text-gray-600 mt-2">{t("Choose a path to start your journey")}</p>
      </div>

      {/* Content */}
      <div className="max-w-6xl mx-auto">
        {isLoading && (
          <div className="text-center animate-pulse text-blue-500 font-semibold text-lg">
            {t("Loading categories...")}
          </div>
        )}

        {error && (
          <div className="text-center text-red-600 font-medium text-md">
            {t("Failed to load categories")}: {error}
          </div>
        )}

        {!isLoading && !error && Array.isArray(categories) && categories.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {categories.map((category, index) => (
              <Link
                key={index}
                to={`/categories/${slugify(category.categoryName)}/${category.id}`}
                state={{ category }}
                className="bg-white/60 backdrop-blur-lg border border-gray-200 rounded-2xl p-6 shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer hover:scale-105"
              >
                <h2 className="text-xl font-semibold text-gray-800 mb-2">
                  {category.categoryName}
                </h2>
                <p className="text-gray-600 text-sm">
                  {category.description || "Start your learning path now!"}
                </p>
              </Link>
            ))}
          </div>
        )}

        {!isLoading && !error && Array.isArray(categories) && categories.length === 0 && (
          <div className="text-center text-gray-500">
            {t("No categories available at the moment.")}
          </div>
        )}
      </div>
    </div>
  );
};

export default Skillup;
